import styles from './PageNotFound.module.css';

const PageNotFound = () => {
  return (
    <div className={styles.container}>
      <h1>Erro 404 - Página não encontrada</h1>
      <h2>Clique em voltar ou navegue no menu acima</h2>
    </div>
  );
};

export default PageNotFound;
